import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { UPDATE_TENANT } from "@/hooks";
import type { UpdateTenantMutation } from "@/types/graphql";

type UpdateTenantResponse = {
  updateTenant: UpdateTenantMutation;
};

export const useUpdateTenant = (
  onCompleted: () => void = () => {},
  onError: (_error: string) => void = (_error) => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [updateTenant, { loading, data }] = useMutation<UpdateTenantResponse>(
    UPDATE_TENANT,
    {
      onCompleted: (response) => {
        if (response.updateTenant?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    updateTenant,
    loading,
    success,
    data,
    resetForm,
  };
};
